/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  shipping-billing-actions.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date		 : Aug 08, 2019
 *
 * @Version      : Version 1.0
 * *
 * By            : Madhu Gali
 * On            : Aug 08, 2019
 * Description   : ASDS-955: Shipping & Billing - Payment Info - PO - API integration
 *  *
 * By            : Avanthi G
 * On            : Aug 09, 2019
 * Description   : ASDS-956: Shipping & Billing - Added Payment Info values to store
 *
 * By            : Madhu Gali (H175591)
 * On            : Aug 23, 2019
 * Description   : ASDS-1089: Ability to add Email Functionality & Validations.
 *
 * By            : Madhu Gali
 * On            : Sep 19 2019
 * Description   : ASDS-165
 *
 * By            	: Madhu Gali - H175591
 * On            	: Oct 10, 2019
 * Description      : ASDS-1476
 *
 * By            	: sivateja.p (H267743)
 * On            	: Oct 10, 2019
 * Description      : added shipping and billing defaults and checkbox updates(ASDS-1296)
 *
 * By            : SandeepRaja (E807238)
 * On            : Oct 17, 2019
 * Description   : ASDS-113: Configure and purchase 131-9 APU through PO
 *
 * By            : E807958
 * On            : 25 Nov 2019
 * Description   : ASDS-1676
 *
 * By            : H224423
 * On            : Dec 9, 2019
 * Description   : Removed shipping & billing checkbox
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Jan 06,2020
 * Description   : updated code as per ASDS-1764.
 *
 * By            : H422337
 * On            : Oct 08, 2020
 * Description   : ASDS - 3228 UI Enhancements for Phase - II
 *
 * By            : H422335
 * On            : Oct 09, 2020
 * Description   : ASDS-3035 Migration of backend URLs to Forge endpoints
 ******************************************************************************/

import Reducer from './reducer';
import { AsdsReduxAction, AsdsReducerObject } from '../../../../../types';
import CheckoutActionConstants from '../action-constants';
import { createReducer } from '../utils/redux-util';

class ShippingBillingReducer extends Reducer {

    /**
     * ASDS-955
     * @param state
     * @param {AsdsReduxAction} action
     * @returns {AsdsReducerObject}
     */
    static getCustomerCBDStatus(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                shippingBillingObj: {
                    ...state.payload.shippingBillingObj,
                    payTerm: action.payload.response.status.payTerm,
                }
            }
        };
    }

    /**
     * ASDS-956
     * @param state
     * @param {AsdsReduxAction} action
     * @returns {AsdsReducerObject}
     */
    static setPaymentInfo(state, action: AsdsReduxAction): AsdsReducerObject {
        let { poNumber, poDate, poFilePath, doc, poContentType } = action.payload.response;
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                shippingBillingObj: {
                    ...state.payload.shippingBillingObj,
                    paymentObj: {
                        ...state.payload.shippingBillingObj.paymentObj,
                        paymentStatus: false,
                        paymentMode: 'PO',
                        poData: {
                            poNumber: poNumber,
                            poDate: poDate,
                            poFileName: poFilePath,
                            poContentType: poContentType,
                            poDocument: doc,
                        }
                    },
                }
            }
        };
    }

    /**
     * ASDS-1089
     * @description: This method validates, adds and updates email addresses added by the user in store.
     * @param state
     * @param {AsdsReduxAction} action
     * @returns {AsdsReducerObject}
     */
    static addUpdateEmailAddress(state, action: AsdsReduxAction): AsdsReducerObject {
        let { emailAddress, enableReviewOrderBtn } = action.payload.response;
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                shippingBillingObj: {
                    ...state.payload.shippingBillingObj,
                    emailAddress: emailAddress,
                    enableReviewOrderBtn: enableReviewOrderBtn
                }
            }
        };
    }

    /**
     * ASDS-165
     * @description: This method adds the paymetric CC data to store.
     * @param state
     * @param {AsdsReduxAction} action
     * @returns {AsdsReducerObject}
     */
    static updateCCPaymentData(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                shippingBillingObj: {
                    ...state.payload.shippingBillingObj,
                    paymentObj: {
                        ...action.payload.response,
                        contractPurchaseData: state.payload.shippingBillingObj.paymentObj.contractPurchaseData,
                    },
                }
            }
        };
    }

    /**
     * ASDS-165
     * @description: This method toggles between showing and hiding loader while CC details are being validated.
     * @param state
     * @param {AsdsReduxAction} action
     * @returns {AsdsReducerObject}
     */
    static updateIsValidatingFlag(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                validationsFlag: {
                    isValidating: action.payload.response,
                }
            }
        };
    }

    static loadShippingBillingDefaults(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                shippingBillingObj: {
                    ...state.payload.shippingBillingObj,
                    emailAddress: action.payload.emailAddress
                }
            }
        };
    }

    /**
     * ASDS-1476
     * @description This updates the value of review order button.
     * @param _state
     * @param action
     */
    static toggleEnableReviewOrderBtnStatus(_state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            ..._state,
            payload: {
                ..._state.payload,
                shippingBillingObj: {
                    ..._state.payload.shippingBillingObj,
                    enableReviewOrderBtn: action.payload.response,
                }
            }
        };
    }

    static updatePaymentRequiredStatus(_state, action: AsdsReduxAction) {
        return {
            ..._state,
            payload: {
                ..._state.payload,
                shippingBillingObj: {
                    ..._state.payload.shippingBillingObj,
                    paymentRequired: action.payload.paymentRequired,
                }
            }
        };
    }

    static updatePurchaseByContractData(state, action: AsdsReduxAction) {
        return {
            isSuccess: true,
            isFetching: false,
            payload: {
                ...state.payload,
                shippingBillingObj: {
                    ...state.payload.shippingBillingObj,
                    paymentObj: {
                        ...state.payload.shippingBillingObj.paymentObj,
                        contractPurchaseData: action.payload.response,
                    },

                }
            }
        };
    }

    static resetShippingBillingData () {
        return initialState;
    }
    static updateCCPaymentFailure(state, action:AsdsReduxAction){
        return {
            ...state,
            payload: {
                ...state.payload,
                shippingBillingObj: {
                    ...state.payload.shippingBillingObj,
                    creditCardPaymentFailure: action.payload.creditCardPaymentFailure,
                }
            }
        };
    }
}

const handlers = {
    [CheckoutActionConstants.GET_CUSTOMER_CBD_STATUS]: ShippingBillingReducer.getCustomerCBDStatus,
    [CheckoutActionConstants.SET_CUSTOMER_PAYMENT_INFO]: ShippingBillingReducer.setPaymentInfo,
    [CheckoutActionConstants.ADD_UPDATE_EMAIL_ADDRESS]: ShippingBillingReducer.addUpdateEmailAddress,
    [CheckoutActionConstants.UPDATE_PAYMENT_MODE_CC_DATA]: ShippingBillingReducer.updateCCPaymentData,
    [CheckoutActionConstants.UPDATE_IS_VALIDATING_FLAG]: ShippingBillingReducer.updateIsValidatingFlag,
    [CheckoutActionConstants.GET_DEFAULT_EMAIL]: ShippingBillingReducer.loadShippingBillingDefaults,
    [CheckoutActionConstants.TOGGLE_ENABLE_REVIEW_ORDER_BTN]: ShippingBillingReducer.toggleEnableReviewOrderBtnStatus,
    [CheckoutActionConstants.UPDATE_PAYMENT_REQUIRED]: ShippingBillingReducer.updatePaymentRequiredStatus,
    [CheckoutActionConstants.UPDATE_CONTRACT_PURCHASE_DATA]: ShippingBillingReducer.updatePurchaseByContractData,
    [CheckoutActionConstants.RESET_SHIPPING_BILLING_DATA]: ShippingBillingReducer.resetShippingBillingData,
    [CheckoutActionConstants.UPDATE_CC_PAYMENT_FAILURE] : ShippingBillingReducer.updateCCPaymentFailure
};

/**
 * @description This constant contains the default values which are mandatory to render the AddEmailAddress component.
 *              Modify with caution.
 * @type {{payload: {shippingBillingObj: {emailAddress: {address: string; error: string}[]; enableReviewOrderBtn: boolean; payTerm: string; paymentObj: {paymentStatus: boolean; paymentMode: string; ccData: {ccNumber: string; ccTypeId: string; ccTypeDesc: string; expiryDate: string; expiryMonth: string; expiryYear: string; ccCvNumber: string; nameOnCard: string; sToken: string; ccTokenResp: string}; poData: {poNumber: string; poDate: string; poDocument: string; poDocId: string; poFileName: string; poContentType: string}}}; shippingBillingPaymentInfo: {poNumber: string; poDate: string; poFilePath: string}; validationsFlag: {isValidating: boolean}}}}
 */
const initialState = {
    isSuccess: true,
    isFetching: false,
    payload: {
        shippingBillingObj:
        {
            paymentRequired: true,
            emailAddress: [{ address: '', error: '' }],
            enableReviewOrderBtn: false,
            payTerm: '',
            paymentObj: {
                paymentStatus: false,
                paymentMode: '',
                ccData: {
                    ccNumber: '',
                    ccTypeId: '',
                    ccTypeDesc: '',
                    expiryDate: '',
                    expiryMonth: '',
                    expiryYear: '',
                    ccCvNumber: '',
                    nameOnCard: '',
                    sToken: '',
                    ccTokenResp: '',
                },
                poData: {
                    poNumber: '',
                    poDate: '',
                    poDocument: '',
                    poDocId: '',
                    poFileName: '',
                    poContentType: '',
                },
                contractPurchaseData: [
                    {
                        contractNo: '',
                        expiryDate: '',
                    }
                ],

            },
            creditCardPaymentFailure: false
        },
        shippingBillingPaymentInfo: {
            poNumber: '',
            poDate: '',
            poFilePath: '',
        },
        validationsFlag: {
            isValidating: false,
        }

    },
};

export const shippingBillingData = createReducer(initialState, handlers);